import React, { useEffect } from "react";

const BotpressChat = ({ menuState }) => {
    useEffect(() => {
        const injectScript = (src, async = true) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = src;
                script.async = async;
                script.onload = () => resolve();
                script.onerror = () => reject(`Failed to load script: ${src}`);
                document.body.appendChild(script);
            });
        };

        const injectStylesToIframeWrapper = () => {
            const interval = setInterval(() => {
                const iframe = document.querySelector("iframe.bpWebchat");
                if (iframe) {
                    const iframeWrapper = iframe.parentElement;

                    // Define styles for the chat widget (desktop and mobile)
                    const desktopStyles = {
                        width: "1240px",
                        height: "540px",
                        position: "absolute",
                        top: "140px",
                        right: "152px",
                        zIndex: "9999",
                        borderRadius: "10px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                        border: "none",
                    };

                    const mobileStyles = {
                        width: "85%",
                        height: "400px",
                        position: "absolute",
                        top: menuState ? "350px" : "100px",
                        left: "5%",
                        zIndex: "9999",
                        borderRadius: "10px",
                        border: "none",
                        marginBottom: "10px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        boxSizing: "border-box",
                    };

                    // Apply responsive styles
                    const applyResponsiveStyles = () => {
                        if (window.innerWidth <= 768) {
                            Object.assign(iframe.style, mobileStyles);
                        } else {
                            Object.assign(iframe.style, desktopStyles);
                        }
                    };

                    applyResponsiveStyles(); // Initial application
                    window.addEventListener("resize", () => {
                        applyResponsiveStyles();
                    });

                    // Ensure the wrapper doesn't affect page design
                    if (iframeWrapper) {
                        iframeWrapper.style.position = "relative";
                        iframeWrapper.style.zIndex = "auto";
                    }

                    clearInterval(interval);
                    document.body.style.overflow = "auto"; // Ensure scrolling is allowed
                    document.documentElement.style.overflow = "auto";
                }
            }, 500);
        };

        const ensureChatbotIsOpen = () => {
            if (window.botpress && !window.botpress.isOpen) {
                window.botpress.open();
            }
        };

        const initializeBotpress = async () => {
            try {
                await injectScript("https://cdn.botpress.cloud/webchat/v2.2/inject.js");
                await injectScript("https://files.bpcontent.cloud/2024/10/13/06/20241013065349-YUNQ1YC3.js");
                await injectScript("https://mediafiles.botpress.cloud/da27d8cd-86be-4163-9303-3597f6c2b40f/webchat/v2.1/config.js");

                if (window.botpress) {
                    window.botpress.init({
                        botId: "da27d8cd-86be-4163-9303-3597f6c2b40f",
                        clientId: "REPLACE_WITH_CLIENT_ID",
                        hostUrl: "https://cdn.botpress.cloud/webchat",
                        messagingUrl: "https://cdn.botpress.cloud",
                        botName: "Chatbot",
                        showCloseButton: false,
                        showPoweredBy: false,
                        enableReset: true,
                    });

                    window.botpress.open();
                    injectStylesToIframeWrapper();

                    // Wait for iframe to load completely and then hide the specific close button path
                    const iframe = document.querySelector("iframe.bpWebchat");

                    // MutationObserver to monitor when the path is injected
                    const observer = new MutationObserver(() => {
                        const pathElement = iframe.contentWindow.document.querySelector("svg path[d='M6 18 18 6M6 6l12 12']");

                        if (pathElement) {
                            // Hide the parent <svg> element containing the path
                            const svgElement = pathElement.closest("svg");
                            if (svgElement) {
                                svgElement.style.display = "none"; // Hides the entire <svg> element
                            }
                            observer.disconnect(); // Stop observing after the element is found and hidden
                        }
                    });

                    // Start observing the iframe's content for changes
                    observer.observe(iframe.contentWindow.document, { childList: true, subtree: true });

                    // Inject custom CSS to hide the FAB button
                    const style = document.createElement("style");
                    style.innerHTML = `
            /* Hide the FAB button */
            #bpFab {
              visibility: hidden !important;
            }
            .bpFab {
              display: none !important;
            }
          `;
                    document.head.appendChild(style);

                    // Ensure the chatbot is open after initialization
                    setTimeout(ensureChatbotIsOpen, 1000);
                }
            } catch (error) {
                console.error("Error initializing Botpress:", error);
            }
        };

        initializeBotpress();

        return () => {
            const scripts = document.querySelectorAll('script[src*="botpress"]');
            scripts.forEach((script) => document.body.removeChild(script));

            const iframe = document.querySelector("iframe.bpWebchat");
            if (iframe) iframe.remove();
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        };
    }, [menuState]);

    return null;
};

export default BotpressChat;




// import React, { useEffect } from "react";

// const BotpressChat = () => {
//     useEffect(() => {
//         const injectScript = (src, async = true) => {
//             return new Promise((resolve, reject) => {
//                 const script = document.createElement("script");
//                 script.src = src;
//                 script.async = async;
//                 script.onload = () => resolve();
//                 script.onerror = () => reject(`Failed to load script: ${src}`);
//                 document.body.appendChild(script);
//             });
//         };

//         const injectStylesToIframeWrapper = () => {
//             const interval = setInterval(() => {
//                 const iframe = document.querySelector("iframe.bpWebchat");
//                 if (iframe) {
//                     const iframeWrapper = iframe.parentElement;

//                     // Define styles for the chat widget (desktop and mobile)
//                     const desktopStyles = {
//                         width: "1300px",
//                         height: "540px",
//                         position: "absolute",
//                         top: "140px",
//                         right: "100px",
//                         zIndex: "9999",
//                         borderRadius: "10px",
//                         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
//                         border: "none",
//                     };

//                     const mobileStyles = {
//                         width: "90%",
//                         height: "400px",
//                         position: "absolute",
//                         top: "290px",
//                         left: "5%",
//                         zIndex: "9999",
//                         borderRadius: "10px",
//                         border: "none",
//                         marginBottom: "10px",
//                         overflowY: "auto",
//                         overflowX: "hidden",
//                         boxSizing: "border-box",
//                     };

//                     // Apply responsive styles
//                     const applyResponsiveStyles = () => {
//                         if (window.innerWidth <= 768) {
//                             Object.assign(iframe.style, mobileStyles);
//                         } else {
//                             Object.assign(iframe.style, desktopStyles);
//                         }
//                     };

//                     applyResponsiveStyles(); // Initial application
//                     window.addEventListener("resize", applyResponsiveStyles);

//                     // Ensure the wrapper doesn't affect page design
//                     if (iframeWrapper) {
//                         iframeWrapper.style.position = "relative";
//                         iframeWrapper.style.zIndex = "auto";
//                     }

//                     clearInterval(interval);

//                     // Allow scrolling for the main page when chatbot is open
//                     document.body.style.overflow = "auto";

//                     // Double-click event on the iframe
//                     iframe.addEventListener("dblclick", () => {
//                         console.log("Iframe was double-clicked!");
//                     });
//                 }
//             }, 500);
//         };

//         const ensureChatbotIsOpen = () => {
//             if (window.botpress && !window.botpress.isOpen) {
//                 console.log("Opening chatbot programmatically...");
//                 window.botpress.open();
//             }
//         };

//         const initializeBotpress = async () => {
//             try {
//                 await injectScript("https://cdn.botpress.cloud/webchat/v2.2/inject.js");
//                 await injectScript("https://files.bpcontent.cloud/2024/10/13/06/20241013065349-YUNQ1YC3.js");
//                 await injectScript("https://mediafiles.botpress.cloud/da27d8cd-86be-4163-9303-3597f6c2b40f/webchat/v2.1/config.js");

//                 if (window.botpress) {
//                     window.botpress.init({
//                         botId: "da27d8cd-86be-4163-9303-3597f6c2b40f",
//                         clientId: "REPLACE_WITH_CLIENT_ID",
//                         hostUrl: "https://cdn.botpress.cloud/webchat",
//                         messagingUrl: "https://cdn.botpress.cloud",
//                         botName: "Chatbot",
//                         showCloseButton: true,
//                         showPoweredBy: false,
//                         enableReset: true,
//                     });

//                     window.botpress.open();
//                     injectStylesToIframeWrapper();

//                     // Ensure the chatbot is open after initialization
//                     setTimeout(ensureChatbotIsOpen, 1000);
//                 }
//             } catch (error) {
//                 console.error(error);
//             }
//         };

//         initializeBotpress();

//         return () => {
//             const scripts = document.querySelectorAll('script[src*="botpress"]');
//             scripts.forEach((script) => document.body.removeChild(script));

//             const iframe = document.querySelector("iframe.bpWebchat");
//             if (iframe) iframe.remove();

//             // Restore scroll behavior on component unmount
//             document.body.style.overflow = "auto";
//         };
//     }, []);

//     return null;
// };

// export default BotpressChat;

// import React, { useEffect } from "react";

// const BotpressChat = ({ menuState }) => {
//     useEffect(() => {
//         const injectScript = (src, async = true) => {
//             return new Promise((resolve, reject) => {
//                 const script = document.createElement("script");
//                 script.src = src;
//                 script.async = async;
//                 script.onload = () => resolve();
//                 script.onerror = () => reject(`Failed to load script: ${src}`);
//                 document.body.appendChild(script);
//             });
//         };

//         const injectStylesToIframeWrapper = () => {
//             const interval = setInterval(() => {
//                 const iframe = document.querySelector("iframe.bpWebchat");
//                 if (iframe) {
//                     const iframeWrapper = iframe.parentElement;

//                     // Define styles for the chat widget (desktop and mobile)
//                     const desktopStyles = {
//                         width: "1240px",
//                         height: "540px",
//                         position: "absolute",
//                         top: "140px",
//                         right: "152px",
//                         zIndex: "9999",
//                         borderRadius: "10px",
//                         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
//                         border: "none",
//                     };

//                     const mobileStyles = {
//                         width: "85%",
//                         height: "400px",
//                         position: "absolute",
//                         top: menuState ? "350px" : "100px",
//                         left: "5%",
//                         zIndex: "9999",
//                         borderRadius: "10px",
//                         border: "none",
//                         marginBottom: "10px",
//                         overflowY: "auto",
//                         overflowX: "hidden",
//                         boxSizing: "border-box",
//                     };

//                     // Apply responsive styles
//                     const applyResponsiveStyles = () => {
//                         if (window.innerWidth <= 768) {
//                             Object.assign(iframe.style, mobileStyles);
//                         } else {
//                             Object.assign(iframe.style, desktopStyles);
//                         }
//                     };

//                     applyResponsiveStyles(); // Initial application
//                     window.addEventListener("resize", () => {
//                         applyResponsiveStyles();
//                     });

//                     // Ensure the wrapper doesn't affect page design
//                     if (iframeWrapper) {
//                         iframeWrapper.style.position = "relative";
//                         iframeWrapper.style.zIndex = "auto";
//                     }

//                     clearInterval(interval);
//                     document.body.style.overflow = "auto"; // Ensure scrolling is allowed
//                     document.documentElement.style.overflow = "auto";
//                     // Double-click event on the iframe
//                     iframe.addEventListener("dblclick", () => {
//                     });
//                 }
//             }, 500);
//         };

//         const ensureChatbotIsOpen = () => {
//             if (window.botpress && !window.botpress.isOpen) {
//                 window.botpress.open();
//             }
//         };

//         const initializeBotpress = async () => {
//             try {
//                 await injectScript("https://cdn.botpress.cloud/webchat/v2.2/inject.js");
//                 await injectScript("https://files.bpcontent.cloud/2024/10/13/06/20241013065349-YUNQ1YC3.js");
//                 await injectScript("https://mediafiles.botpress.cloud/da27d8cd-86be-4163-9303-3597f6c2b40f/webchat/v2.1/config.js");

//                 if (window.botpress) {
//                     window.botpress.init({
//                         botId: "da27d8cd-86be-4163-9303-3597f6c2b40f",
//                         clientId: "REPLACE_WITH_CLIENT_ID",
//                         hostUrl: "https://cdn.botpress.cloud/webchat",
//                         messagingUrl: "https://cdn.botpress.cloud",
//                         botName: "Chatbot",
//                         showCloseButton: false,
//                         showPoweredBy: false,
//                         enableReset: true,
//                     });

//                     window.botpress.open();
//                     injectStylesToIframeWrapper();

//                     // Inject custom CSS to hide the Botpress FAB button
//                     const style = document.createElement("style");
//                     style.innerHTML = `
//                         #bpFab {
//                             visibility: hidden !important;
//                         }
//                         .bpFab {
//                             display: none !important;
//                         }
//                     `;
//                     document.head.appendChild(style);

//                     // Ensure the chatbot is open after initialization
//                     setTimeout(ensureChatbotIsOpen, 1000);
//                 }
//             } catch (error) {
//             }
//         };

//         initializeBotpress();

//         return () => {
//             const scripts = document.querySelectorAll('script[src*="botpress"]');
//             scripts.forEach((script) => document.body.removeChild(script));

//             const iframe = document.querySelector("iframe.bpWebchat");
//             if (iframe) iframe.remove();
//             document.body.style.overflow = "auto";
//             document.documentElement.style.overflow = "auto";
//         };
//     }, [menuState]);

//     return null;
// };

// export default BotpressChat;
